import React from 'react';
import ReactTooltip from 'react-tooltip';
import {
  BodyStyleConfig,
  SectionAppearance,
} from '../../../utils/api/pdfLayout';
import { APPEARANCE_OPTIONS, StyleFields } from './SectionStyleControls';

interface Props {
  // section name, e.g. "Findings Log": titles the inputs and keys the tooltip
  label: string;
  appearance?: SectionAppearance;
  bodyStyle: BodyStyleConfig;
  paddingTip: string;
  onChange: (fields: {
    appearance?: SectionAppearance;
    body_style?: BodyStyleConfig;
  }) => void;
}

const TEXT_FIELDS = ['fontStyle', 'fontSize', 'color'];

// SW2-2344: the question groups' Appearance / text / padding controls, for the Findings
// Log and Certification sections. Nothing set = the section prints as it always has.
const SectionBodyControls: React.FC<Props> = ({
  label,
  appearance,
  bodyStyle,
  paddingTip,
  onChange,
}) => {
  // unique per section, so the two padding tooltips don't share one
  const tooltipId = `${label.toLowerCase().replace(/\W+/g, '-')}-padding-tooltip`;

  return (
    <div className='ple-section-style__row'>
      <div className='ple-field'>
        <span className='ple-field__label'>Appearance</span>
        <div className='ple-seg ple-seg--block'>
          {APPEARANCE_OPTIONS.map((option) => (
            <button
              key={option.value}
              type='button'
              className={
                (appearance ?? 'border') === option.value ? 'is-active' : ''
              }
              onClick={() =>
                onChange({ appearance: option.value as SectionAppearance })
              }
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>
      <StyleFields
        label='Text'
        fields={TEXT_FIELDS}
        value={bodyStyle}
        onChange={(body_style: BodyStyleConfig) => onChange({ body_style })}
      />
      <div className='ple-field'>
        <span className='ple-field__label'>
          Padding
          <i
            className='fa fa-info-circle ple-tooltip__icon'
            data-for={tooltipId}
            data-tip={paddingTip}
          />
          <ReactTooltip
            id={tooltipId}
            place='top'
            effect='solid'
            className='ple-tooltip'
          />
        </span>
        <input
          className='ple-input ple-input--size'
          type='number'
          min={1}
          max={100}
          step={1}
          title={`${label} padding (px)`}
          value={parseFloat(String(bodyStyle.padding)) || ''}
          onChange={(e) =>
            onChange({
              body_style: {
                ...bodyStyle,
                padding:
                  e.target.value !== ''
                    ? `${Math.min(100, Math.max(1, Math.round(Number(e.target.value)) || 1))}px`
                    : undefined,
              },
            })
          }
        />
      </div>
    </div>
  );
};

export default SectionBodyControls;
